import "react-step-progress-bar/styles.css";
import { ProgressBar } from "react-step-progress-bar";

const ProgressBarComponent = ({ current }: any) => {
  return <ProgressBar percent={current} filledBackground="#1abc13" />;
};

export default ProgressBarComponent;
